<template>
  <div class="filters">
    <filters-group
      v-for="(filter, name) in filters"
      :key="name"
      :label="filter.label"
      v-if="isEvent(filter) && isStatus(name)"
      :is-dirty="!isEmpty(values[name])"
    >
      <component
        :is="`filter-${filter.type}`"
        :filters="cleanValues"
        :endpoint="endpoint"
        :name="name"
        :endpointMethod="endpointMethod"
        v-bind="filter.params"
        v-model="values[name]"
      ></component>
    </filters-group>

    <filters-group
      label="По состоянию автомата"
      v-if="hasStatus"
      :is-dirty="isDirty('status')"
    >
      <filters-group
        v-for="(filter, name) in filters"
        :key="name"
        :label="filter.label"
        v-if="name.indexOf('status') !== -1"
        :is-dirty="!isEmpty(values[name])"
      >
        <component
          :is="`filter-${filter.type}`"
          :filters="cleanValues"
          :endpoint="endpoint"
          :name="name"
          :endpointMethod="endpointMethod"
          v-bind="filter.params"
          v-model="values[name]"
        ></component>
      </filters-group>
    </filters-group>

    <filters-group
      label="По свойствам событий"
      v-if="hasEvent"
      :is-dirty="isDirty('event')"
    >
      <filters-group
        v-for="(filter, name) in filters"
        :key="name"
        :label="filter.label"
        v-if="name.indexOf('event') !== -1"
        :is-dirty="!isEmpty(values[name])"
      >
        <component
          :is="`filter-${filter.type}`"
          :filters="cleanValues"
          :endpoint="endpoint"
          :name="name"
          :endpointMethod="endpointMethod"
          v-bind="filter.params"
          v-model="values[name]"
        ></component>
      </filters-group>
    </filters-group>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { omitBy, isEmpty, clone, isEqual } from 'lodash'

  export default {
    name: 'Filters',
    props: {
      value: {},
      filters: {},
      endpoint: {},
      endpointMethod: {
        default: () => 'get',
      },
    },
    data () {
      return {
        values: clone(this.value || {}),
        hasEvent: false,
        hasStatus: false,
      }
    },
    methods: {
      isEmpty,
      isEvent (filter) {
        if (filter.type.indexOf('event') !== -1) {
          this.hasEvent = true
        }
        return filter.type.indexOf('event') === -1
      },
      isStatus (name) {
        if (name.indexOf('status') !== -1) {
          this.hasStatus = true
        }
        return name.indexOf('status') === -1
      },
      collapseAll () {
        $('.filters-group-collapse.show', this.$el).collapse('hide')
      },
      isDirty (groupName) {
        return Object.entries(this.filters)
          .some((filter) => filter[0].indexOf(groupName) !== -1 && !isEmpty(this.values[filter[0]]))
      },
    },
    computed: {
      cleanValues () {
        return omitBy(clone(this.values), isEmpty)
      },
    },
    watch: {
      value (val, oldVal) {
        if (!isEqual(oldVal, val)) {
          this.values = clone(val || {})
        }
      },
    },
    mounted () {
      Object.keys(this.filters).forEach((name) => {
        this.$set(this.values, name, this.values[name])
      })

      this.$watch('values', () => {
        this.$emit('input', this.cleanValues)
      }, {deep: true})
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filters.vue